import { EFinancingCompany } from '@if/core/types'
import { formatAddress } from '@if/core/utils'
import EditIcon from '@mui/icons-material/Edit'
import { IconButton, Stack, Typography } from '@mui/material'
import MerchantDashboardAccess from '@src/components/MerchantDashboardAccess'
import { Address } from '@src/data/types/Address'
import { Merchant } from '@src/data/types/Merchant'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  banner: Merchant
}

const BannerInformation = ({ banner }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const address: Address = {
    stateIso: banner?.province,
    city: banner?.city,
    country: banner?.country,
    postalCode: banner?.zipCode,
    street: banner?.address,
  } as Address

  if (!banner) return null

  const handleEditClick = () => {
    navigate(`/banner/${banner.id}/edit?financingCompanyId=${banner.financingCompanyId}`)
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} padding={2}>
      <Typography variant="h6" component="div">
        {banner.name}
        <Typography variant="body1" component="div">
          {formatAddress(address)}
        </Typography>
      </Typography>
      <Stack direction="row" gap={1} alignItems="center">
        <Typography variant="body1" component="div" sx={{ border: '1px solid', borderRadius: 2, p: 1 }}>
          {t('common.program')} :{' '}
          {banner.supportedFinancingPrograms.map((e) => t(`EFinancingProgram.${e}`, { ns: 'enum' })).join(', ')}
        </Typography>

        <Typography
          variant="body1"
          component="div"
          sx={{ border: '2px solid', borderRadius: 2, p: 1, borderColor: 'error.main', float: 'right' }}
        >
          {t(`ELanguageAbbr.${banner.languageId}`, { ns: 'enum' })} | {banner.province}
        </Typography>
        <MerchantDashboardAccess merchantId={banner.id} />
        <IconButton
          id="btnEditBanner"
          aria-label="edit-banner"
          color="primary"
          onClick={handleEditClick}
          disabled={banner.financingCompanyId === EFinancingCompany.Iceberg}
        >
          <EditIcon />
        </IconButton>
      </Stack>
    </Stack>
  )
}

export default BannerInformation
